export default function AboutSection() {
  return (
    <section
      id="about"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50 scroll-mt-16"
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
          关于人人影视
        </h2>
        <div className="mt-2 w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>
        <p className="mt-6 text-sm md:text-base text-foreground-700 leading-relaxed max-w-3xl mx-auto">
          人人影视成立于热爱影视的社区之中，是专注于高清免费在线观看的综合性影视平台。我们以"不缓冲秒播"为核心技术标准，覆盖热门电视剧全集、电影大全、动漫、综艺、纪录片等丰富内容。平台每日同步更新海内外最新剧集，所有资源均支持高清画质播放，免注册即可畅享。人人影视坚持以用户观影体验为中心，不断优化播放引擎与内容库，致力于为每一位影迷打造最便捷、最高清、最全面的免费影视观看入口。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          <div className="text-center">
            <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500">10万+</div>
            <div className="mt-1 text-xs text-foreground-600">影视资源</div>
          </div>
          <div className="w-px h-10 bg-background-200"></div>
          <div className="text-center">
            <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500">500万+</div>
            <div className="mt-1 text-xs text-foreground-600">日活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-200"></div>
          <div className="text-center">
            <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500">8年</div>
            <div className="mt-1 text-xs text-foreground-600">持续运营</div>
          </div>
        </div>
      </div>
    </section>
  );
}